import {
  useQuery, useMutation, useQueryClient 
} from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from './use-auth';
import {
  getSupplierInvoices, submitInvoice, type InvoiceFilters 
} from '../api/invoices-client';

export function useInvoices(filters?: InvoiceFilters) {
  const { user } = useAuth();
  const supplierId = user?.supplierId ?? '';

  return useQuery({
    queryKey: ['invoices', supplierId, filters],
    queryFn: () => getSupplierInvoices(supplierId, filters),
    enabled: Boolean(supplierId),
  });
}

export function useSubmitInvoice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invoiceId: string) => submitInvoice(invoiceId),
    onSuccess: () => {
      toast.success('Invoice submitted successfully');
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
    },
    onError: (error) => {
      toast.error(`Failed to submit invoice: ${error.message}`);
    },
  });
}
